import type { BadgeProps } from "@mantine/core";
import { Badge } from "@mantine/core";
import { SiteSetupProcessStatus } from "../../../../types/api.types";

type DisplayStatusProps = { status?: SiteSetupProcessStatus } & BadgeProps;

export function DisplayStatus({ status, ...badgeProps }: DisplayStatusProps) {
  switch (status) {
    case SiteSetupProcessStatus.NotConfigured:
      return (
        <Badge color="secondary" {...badgeProps}>
          Nicht konfiguriert
        </Badge>
      );
    case SiteSetupProcessStatus.InProgress:
      return (
        <Badge color="warning" {...badgeProps}>
          In Bearbeitung
        </Badge>
      );
    default:
      return;
  }
}
